import { Icon } from '@salecycle/ui-component-library';
import { Droppable } from 'components/experimental/DragAndDrop/Droppable';
import styled from 'styled-components';
import { Handle } from '../Canvas';
import { useTranslation } from 'react-i18next';

const Border = styled.div`
  background-color: ${({ theme }) => theme.vars.newColor.white};
  width: 320px;
  height: 250px;
  border: 0.5px dashed ${({ theme }) => theme.vars.newColor.darkGS2};
  border-radius: 16px;
  padding: 32px 18px;
`;

const IconWrapper = styled.div`
  border-radius: 50%;
  height: 24px;
  width: 24px;
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`;

const IconBorder = styled.div`
  height: 32px;
  width: 88px;
  padding: 4px 32px;
  border: 1px dashed ${({ theme }) => theme.vars.newColor.darkGS3};
  border-radius: 4px;
  position: relative;
  left: 46px;
`;

const DropZoneMessage = styled.h3`
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  text-align: center;
  margin-top: 1rem;
`;

const Cursor = styled.img`
  margin: 5px;
  position: relative;
  z-index: 2;

  animation-name: translateCursor;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes translateCursor {
    0% {
      left: 32px;
      top: -1px;
    }
    30% {
      left: 78px;
      top: 35px;
    }
    100% {
      left: 78px;
      top: 35px;
    }
  }
`;

const DragAndDropTransition = styled.div`
  height: 24px;
  width: 72px;
  position: relative;
  background-color: #cce3ff;
  z-index: 1;

  animation-name: translateBox, expand;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes translateBox {
    0% {
      left: 0px;
      top: -68px;
    }
    30% {
      left: 46px;
      top: -32px;
    }
    100% {
      left: 46px;
      top: -32px;
    }
  }

  @keyframes expand {
    0% {
      height: 24px;
      width: 72px;
    }
    50% {
      height: 24px;
      width: 72px;
    }
    65% {
      width: 88px;
      height: 32px;
    }
    100% {
      width: 88px;
      height: 32px;
      border-radius: 5px;
      border: 1px dashed grey;
    }
  }
`;

const UpperBox = styled.div`
  padding-left: 50px;
  height: 70px;
  width: 100%;
`;

export function MessageDropzoneNode() {
  const { t } = useTranslation('campaigns');

  return (
    <Droppable aria-label="Message Dropzone">
      <Border>
        <Handle type="target" position={'top' as any} />
        <UpperBox>
          <Cursor height="20px" src="/images/cursor.svg" alt="" />
          <IconBorder>
            <IconWrapper>
              <Icon icon="plus" size="lg" />
            </IconWrapper>
          </IconBorder>
          <DragAndDropTransition />
        </UpperBox>
        <DropZoneMessage>{t('onsite.editor.workflow.DragAndDropMessage')}</DropZoneMessage>
        <Handle type="source" position={'bottom' as any} />
      </Border>
    </Droppable>
  );
}
